import React from 'react';

export const LivingGlossaryGuidelines = () => (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
        <h2 style={{ marginBottom: '20px', color: '#2c3e50' }}>Living Glossary Guidelines</h2>
        <ol style={{ marginBottom: '40px' }}>
          <li style={{ marginBottom: '15px' }}>
            We welcome submissions of new terminology or suggestions of changes to existing terms in the living glossary.
          </li>
          <li style={{ marginBottom: '15px' }}>
            Please be sure to add all appropriate key word tags to a new term and to fill out all fields completely, including the source of the term.
          </li>
          <li style={{ marginBottom: '15px' }}>
            New terms and suggested changes are reviewed by members of the International AI in Medicine Education Working Group.
          </li>
          <li style={{ marginBottom: '15px' }}>
            Terms containing profanities or discriminatory/derogatory material will not be accepted.
          </li>
          <li style={{ marginBottom: '15px' }}>
            If you encounter any technical issues, please email us at TCAIREM Info: <a href="mailto:t.cairem@utoronto.ca" style={{ color: '#3498db' }}>t.cairem@utoronto.ca</a>.
          </li>
        </ol>
    </div>
);
